import React, { Children, useEffect, useState } from "react";

//ANT DESIGN IMPORTS
import { Row, Typography, Col, Card, Breadcrumb, Tooltip } from "antd";
import {InfoCircleOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";

//PROJECT IMPORTS
import appLabel from "../../config/appLabel";

const { Text, Title } = Typography;

function TopContent(props) {
  const { pageTitle, pageItems, tooltipInfo } = props;
  const [displayPageItems, setDisplayPageItems] = useState(pageItems)

  useEffect(()=>{
    //INSERT DASHBOARD LINK AS THE FIRST ELEMENT
    let temp = [];
    temp.push({title: <Link to="/dashboard">{appLabel.home}</Link>})
    setDisplayPageItems([...temp, ...pageItems])
  }, [])

  return (
    <Card
      style={{
        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
        borderRadius: 20,
        marginBottom: 25,
      }}
    >
      <Col>
        <Row style={{ marginBottom: 0, marginTop: 0 }}>
          <Title level={3} style={{ margin: 0 }}>
            {pageTitle}&nbsp;{tooltipInfo && <Tooltip title={tooltipInfo}><InfoCircleOutlined style={{cursor:"pointer"}}  /></Tooltip>}
          </Title>
        </Row>
        <Breadcrumb items={displayPageItems} />
      </Col>
    </Card>
  );
}

export default TopContent;
